import React, { useContext, useEffect, useState } from "react";
import { Accordion, Spinner } from "react-bootstrap";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import "../../../assets/css/user/contact us/contactUs.css";
import Navbar from "../../../components/user/navbar/Navbar";
import SimpleBanner from "../../../components/user/general/SimpleBanner";
import Footer from "../../../components/user/footer/Footer";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });
  const [faqs, setFaqs] = useState([]);
  const [faqType, setFaqType] = useState("customer");
  const [sending, setSending] = useState(false);

  const { baseUrl } = useContext(AppContext);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const viewAllFaqs = () => {
    axios
      .get(`${baseUrl}/customer/faqs/viewAllUploadedFaqs`)
      .then((response) => {
        console.log(response.data);

        if (response.data.success) {
          setFaqs(response.data.faqRecords);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllFaqs();
  }, []);

  const filteredFaqs = faqs.filter(
    (faq) => faq.selectedType.toLowerCase() === faqType.toLowerCase()
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSending(true);

    try {
      const response = await axios.post(
        `${baseUrl}/customer/contact/sendMessage`,
        formData
      );

      console.log("Contact Response:", response.data);

      if (response.data.success) {
        alert("Message sent successfully!");

        setFormData({
          fullName: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        alert(response.data.message || "Unable to send message.");
      }
    } catch (error) {
      console.log("CONTACT ERROR:", error);

      alert(
        error.response?.data?.message ||
          "Something went wrong while sending your message."
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <div className="contact-us-container">
        <MarqueeBanner />
        <Navbar />

        <SimpleBanner
          title="Contact us"
          subtitle="We're here to help! Reach out to us anytime."
          breadcrumbs={[
            { label: "Home", href: "/" },
            { label: "contact us", href: "/contact us" },
          ]}
        />

        <Container fluid>
          <Row className="contact-content align-items-stretch mt-5">
            {/* Left Side - Contact Information */}
            <Col lg={5} md={6} sm={12} className="contact-info-col">
              {/* Email Card */}
              <Card className="contact-info-card">
                <div className="contact-info-icon-wrapper email-icon">
                  <Mail size={24} />
                </div>
                <div className="contact-info-content">
                  <h5 className="contact-info-title">Email</h5>
                  <p className="contact-info-text">support@time4pulse.com</p>
                  <p className="contact-info-subtext">
                    We reply within 24 hours
                  </p>
                </div>
              </Card>

              {/* Phone Card */}
              <Card className="contact-info-card">
                <div className="contact-info-icon-wrapper phone-icon">
                  <Phone size={24} />
                </div>
                <div className="contact-info-content">
                  <h5 className="contact-info-title">Phone</h5>
                  <p className="contact-info-text">+92 300 1234567</p>
                  <p className="contact-info-subtext">Mon-Sat, 8AM-8PM</p>
                </div>
              </Card>

              {/* Address Card */}
              <Card className="contact-info-card">
                <div className="contact-info-icon-wrapper address-icon">
                  <MapPin size={24} />
                </div>
                <div className="contact-info-content">
                  <h5 className="contact-info-title">Address</h5>
                  <p className="contact-info-text">
                    Office 301, Tech Tower, Gulberg III, Lahore
                  </p>
                  <p className="contact-info-subtext">Visit us anytime</p>
                </div>
              </Card>
            </Col>

            {/* Right Side - Contact Form */}
            <Col lg={7} md={6} sm={12} className="contact-form-col">
              <Card className="contact-form-card">
                <h3 className="form-card-title">Send a Message</h3>

                <Form onSubmit={handleSubmit}>
                  <Row>
                    {/* Full Name */}
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="contact-form-label">
                          Full Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleInputChange}
                          placeholder="Your name"
                          required
                          className="contact-form-input"
                        />
                      </Form.Group>
                    </Col>

                    {/* Email */}
                    <Col md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label className="contact-form-label">
                          Email
                        </Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="your@email.com"
                          required
                          className="contact-form-input"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Subject */}
                  <Form.Group className="mb-3">
                    <Form.Label className="contact-form-label">
                      Subject
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      placeholder="How can we help?"
                      required
                      className="contact-form-input"
                    />
                  </Form.Group>

                  {/* Message */}
                  <Form.Group className="mb-4">
                    <Form.Label className="contact-form-label">
                      Message
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      placeholder="Write your message..."
                      required
                      className="contact-form-input contact-form-textarea"
                    />
                  </Form.Group>

                  {/* Submit Button */}
                  <Button
                    type="submit"
                    className="contact-submit-btn"
                    disabled={sending}
                  >
                    {sending ? (
                      <>
                        <Spinner animation="border" size="sm" />
                        <span>Sending...</span>
                      </>
                    ) : (
                      <>
                        <Send size={18} />
                        <span>Send Message</span>
                      </>
                    )}
                  </Button>
                </Form>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* FAQ Section */}
      <section className="faq-section">
        <Container>
          <h2 className="faq-title">Frequently Asked Questions</h2>

          <p className="faq-subtitle">
            Quick answers for customers and sellers
          </p>

          <div className="faq-switch">
            <button
              className={faqType === "customer" ? "faq-btn active" : "faq-btn"}
              onClick={() => setFaqType("customer")}
            >
              For Customers
            </button>

            <button
              className={faqType === "seller" ? "faq-btn active" : "faq-btn"}
              onClick={() => setFaqType("seller")}
            >
              For Sellers
            </button>
          </div>

          <Accordion className="mt-4">
            {filteredFaqs.map((item, index) => (
              <Accordion.Item eventKey={String(index)} key={item.id ?? index}>
                <Accordion.Header>{item.question}</Accordion.Header>
                <Accordion.Body>{item.answer}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default ContactUs;